import request from '@/utils/request'

//查询列表
export function getOwnPaperList(data) {
	return request({
		url: '/api/examinePaper/getOwnPaperList',
		method: 'get',
		params: data
	})
}
//根据id查询试题
export function topicByPaperId(data) {
	return request({
		url: '/api/examinePaper/topicByPaperId',
		method: 'get',
		params: data
	})
}
//添加
export function addPaper(data) {
	return request({
		url: '/api/examinePaper/addPaper',
		method: 'post',
		data
	})
}
//编辑
export function updatePaper(data) {
	return request({
		url: '/api/examinePaper/updatePaper',
		method: 'post',
		data
	})
}

//启用
export function usingPaper(data) {
	return request({
		url: '/api/examinePaper/usingPaper',
		method: 'get',
		params: data
	})
}
//禁用
export function disablePaper(data) {
	return request({
		url: '/api/examinePaper/disablePaper',
		method: 'get',
		params: data
	})
}
//根据id查询
export function getPaperById(data) {
	return request({
		url: '/api/examinePaper/getPaperById',
		method: 'get',
		params: data
	})
}
//删除
export function deletePaper(data) {
	return request({
		url: '/api/examinePaper/deletePaper',
		method: 'get',
		params: data
	})
}
//根据id获取未选择的试题
export function getUnselectedTopicByPaperId(data) {
	return request({
		url: '/api/examinePaper/getUnselectedTopicByPaperId',
		method: 'get',
		params: data
	})
}
//查询启用列表
export function getPaperList(data) {
	return request({
		url: '/api/examinePaper/getPaperList',
		method: 'get',
		params: data
	})
}
